import { ref } from 'vue';

const isOpen = ref(false);
const processoId = ref(null);
const liberado = ref(false);
const liberadoPorNome = ref('');

const open = (pId = null) => {
  processoId.value = pId;
  liberado.value = false;
  liberadoPorNome.value = '';
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
  processoId.value = null;
  liberado.value = false;
  liberadoPorNome.value = '';
};

const notificarLiberado = (gestorNome) => {
  liberadoPorNome.value = gestorNome;
  liberado.value = true;
};

export default {
  isOpen,
  processoId,
  liberado,
  liberadoPorNome,
  open,
  close,
  notificarLiberado,
};
